import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { AuthService } from '../../../services/auth.service';
import { ShareProjectService } from '../../../services/share-project.service';
import { ModalStartScreenComponent } from '../modal-start-screen/modal-start-screen.component';
import { ProjectManagerService } from '../../../services/project-manager.service';
import { ModalSaveComponent } from '../modal-save/modal-save.component';
import { ToasterService } from 'angular2-toaster';
import { LoadingSpinnerService } from '../../../services/loading-spinner.service';
import { SalesDashboardService } from '../../../services/sales-dashboard.service';
import { environment } from '../../../../environments/environment';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-modal-share-email',
  templateUrl: './modal-share-email.component.html',
  styleUrls: ['./modal-share-email.component.scss']
})
export class ModalShareEmailComponent implements OnInit {
  appUrl: string = environment.appUrl;

  url_project: string;

  shareForm: any = {
    receiverEmail: '',
    senderEmail: '',
    subject: 'Feeney Railing Design'
  };

  isAuthorization: boolean = false;
  isSaved: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalShareEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public auth: AuthService,
    public shareSrvc: ShareProjectService,
    public projectSrvc: ProjectManagerService,
    private toasterService: ToasterService,
    private loadingSpinnerService: LoadingSpinnerService,
    private salesDashboardService: SalesDashboardService,
    private analyticsService: AnalyticsService
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }

  login() {
    // this.dialogRef.close();

    let dialogRef = this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      data: 'login-for-sharing'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (this.auth.getEmail() != undefined) {
        this.shareForm.senderEmail = this.auth.getEmail();
      }
    });
  }

  saveProject() {
    // this.dialogRef.close();

    let dialogRef = this.dialog.open(ModalSaveComponent, {
      width: '455px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Save/Rename dialog was closed');
    });
  }

  share() {
    if (this.shareForm.receiverEmail != '' && this.shareForm.senderEmail != '') {
      if (this.data == 'shareProject') {
        this.shareForm.url_project = this.url_project;
        this.shareForm.message = this.shareForm.senderEmail +  ' shared a Feeney design project with you.'
        this.loadingSpinnerService.spinnerLoadingListAdd('shareProject');
        this.shareSrvc.shareProject(this.shareForm).subscribe(
          res => {
            this.loadingSpinnerService.spinnerLoadingListRemove('shareProject');
            this.showToast('success', 'Success', 'Project shared');
            let projectId: any = this.url_project.split('/');
            projectId = projectId[projectId.length - 1];
            this.analyticsService.onUserSharedProject(projectId);
            // console.log(res);
          },
          err => {
            console.log(err);
            this.loadingSpinnerService.spinnerLoadingListRemove('shareProject');
            this.showToast('error', 'Error', 'Something went wrong');
          }
        );
      } else {
        this.loadingSpinnerService.spinnerLoadingListAdd('shareImage');
        this.shareSrvc.shareImages(this.shareForm).subscribe(
          res => {
            this.loadingSpinnerService.spinnerLoadingListRemove('shareImage');
            this.showToast('success', 'Success', 'Image shared');
            // console.log(res);
          },
          err => {
            this.loadingSpinnerService.spinnerLoadingListRemove('shareImage');
            this.showToast('error', 'Error', 'Something went wrong');
          }
        );
      }
    }
    this.dialogRef.close();
  }

  ngOnInit() {
    // console.log(this.data);

    let projectFromSalesDashboardId = this.salesDashboardService.getSelectedProjectId();

    if (this.auth.getEmail() != undefined) {
      this.shareForm.senderEmail = this.auth.getEmail();
    }

    if (this.data != undefined && this.data != 'shareProject') {
      this.shareForm.images = this.data;
      this.shareForm.countImg = this.data.length;
    }

    this.auth.isAuthorization.subscribe(auth => (this.isAuthorization = auth));
    this.projectSrvc.isSavedProject.subscribe(value => {
      this.isSaved = value;
      if (projectFromSalesDashboardId) {
        this.data = 'shareProject';
        this.isSaved = true;
        this.url_project = `${this.appUrl}/browsing/` + projectFromSalesDashboardId;
        this.salesDashboardService.clearSelectedProjId();
      } else if (this.isSaved == true) {
        this.url_project = `${this.appUrl}/browsing/` + this.projectSrvc.getCurrentProjectId();
        // this.url_project = 'http://localhost:4200/browsing/' + this.projectSrvc.getCurrentProjectId();
      }
      // console.log(this.isSaved)
    });
  }

  showToast(type: string, title: string, body: string): void {
    this.toasterService.popAsync(type, title, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-share-email/modal-share-email.component.ts